import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { SunIcon, MoonIcon } from '@heroicons/react/24/solid';
import { toast } from 'react-toastify';

// کامپوننت برای تغییر تم روشن/تیره
const ThemeToggle = () => {
  // دریافت تم اولیه
  const getInitialTheme = () => {
    if (typeof window === 'undefined') return false; // برای SSR
    try {
      const saved = localStorage.getItem('theme');
      if (saved) return saved === 'dark';
      return window.matchMedia('(prefers-color-scheme: dark)').matches;
    } catch (err) {
      console.error('خطای دریافت تم:', err);
      return false; // پیش‌فرض: تم روشن
    }
  };

  const [isDark, setIsDark] = useState(getInitialTheme);

  // به‌روزرسانی تم در DOM و localStorage
  useEffect(() => {
    try {
      document.documentElement.classList.toggle('dark', isDark);
      localStorage.setItem('theme', isDark ? 'dark' : 'light');
    } catch (err) {
      console.error('خطای به‌روزرسانی تم:', err);
      toast.error('Failed to update theme!');
    }
  }, [isDark]);

  // همگام‌سازی با prefers-color-scheme
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handler = (e) => {
      setIsDark(e.matches);
      toast.info(`Switched to ${e.matches ? 'dark' : 'light'} mode by system! 🌗`, {
        theme: e.matches ? 'dark' : 'light',
      });
    };

    mediaQuery.addEventListener('change', handler);
    return () => mediaQuery.removeEventListener('change', handler);
  }, []);

  // تغییر تم با کلیک
  const handleToggle = () => {
    setIsDark((prev) => {
      const newTheme = !prev;
      toast.info(`Switched to ${newTheme ? 'dark' : 'light'} mode! 🌗`, {
        theme: newTheme ? 'dark' : 'light',
      });
      return newTheme;
    });
  };

  return (
    <motion.button
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.9 }}
      onClick={handleToggle}
      className="p-2 rounded-full bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-200 hover:bg-gray-300 dark:hover:bg-gray-600 transition-all duration-200"
      aria-label="Toggle Theme"
    >
      {isDark ? <SunIcon className="h-6 w-6 text-yellow-400" /> : <MoonIcon className="h-6 w-6 text-blue-500" />}
    </motion.button>
  );
};

export default ThemeToggle;